// password content validation rules
const allowedCharactersPattern = /^[a-zA-Z0-9!@#$%^&*()\-_=+{};:,<.>]+$/;
const lowercaseRegex = /.*[a-z]/;
const uppercaseRegex = /.*[A-Z]/;
const digitRegex = /.*\d/;
const specialCharRegex = /.*[!@#$%^&*()\-_=+{};:,<.>]/;

const rules = [lowercaseRegex, uppercaseRegex, digitRegex, specialCharRegex];

export const isPasswordContentValid = password => {
	if (!allowedCharactersPattern.test(password)) return false;

	const passedTests = rules.reduce(
		(count, pattern) => (pattern.test(password) ? count + 1 : count),
		0,
	);

	return passedTests >= 2;
};
